module.exports = __webpack_public_path__ + "static/media/1-03.2661ae66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/1-03.jpg
// module id = 168
// module chunks = 0